import React, { useState } from 'react';

import NavigationTabs from "./NavigationTabs";

import Ethereum from "./ethereum/Ethereum";
import Math from "./math/Math";
import Poseidon from "./poseidon/Poseidon";
import Home from "./home/Home";

import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from '@material-ui/core/IconButton';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const styles = theme => ({
  root: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    flex: '0 0 auto',
    zIndex: theme.zIndex.drawer + 1
  },
  menuButton: {
    marginLeft: -12,
  },
  grow: {
    flexGrow: 1,
    marginLeft: 20,
  },
  body: {
    flex: '1 0 0',
    display: 'flex',
    flexDirection: 'row',
    minHeight: '0'
  },
  navigation: {
    width: '264px',
    maxWidth: '100%'
  },
  content: {
    flex: '1 0 0',
    padding: theme.spacing (4),
    minWidth: '0',
    overflowY: 'auto'
  },
  toolbar: theme.mixins.toolbar
});

const pages = {
  '/ethereum': {label: 'Ethereum', component: Ethereum, title: 'Ethereum'},
  '/math': {label: 'Math', component: Math, title: 'Math'},
  '/poseidon': {label: 'Poseidon', component: Poseidon, title: 'Poseidon'}
};

function App (props) {
  const {
    classes,
    ...other
  } = props;

  const [ navigationOpen, setNavigationOpen ] = useState (false);

  return (
    <Router>
      <CssBaseline />
      <div className={classes.root} {...other}>
        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <Hidden mdUp implementation="css">
              <IconButton className={classes.menuButton} color="inherit" onClick={() => setNavigationOpen (true)}>
                <MenuIcon />
              </IconButton>
            </Hidden>
            <Switch>
              {Object.entries (pages).map (([path, {title}]) =>
                <Route key={path} path={path}>
                  <Typography className={classes.grow} variant="h6" color="inherit" noWrap>
                    ABDK Toolkit: {title}
                  </Typography>
                </Route>
              )}
              <Route path="/">
                <Typography className={classes.grow} variant="h6" color="inherit" noWrap>
                  ABDK Toolkit
                </Typography>
              </Route>
            </Switch>
          </Toolbar>
        </AppBar>
        <div className={classes.body}>
          <Hidden smDown implementation="css">
            <Drawer variant="permanent" className={classes.navigation} classes={{
              paper: classes.navigation,
            }}>
              <div className={classes.toolbar} />
              <NavigationTabs pages={pages} />
            </Drawer>
          </Hidden>
          <Hidden mdUp>
            <Drawer variant="temporary"
                    open={navigationOpen}
                    onClose={() => setNavigationOpen (false)}
                    className={classes.navigation} classes={{
              paper: classes.navigation,
            }}>
              <NavigationTabs pages={pages} onClick={() => setNavigationOpen (false)}/>
            </Drawer>
          </Hidden>
          <div className={classes.content}>
            <Switch>
              {Object.entries (pages).map (([path, {component: Component}]) =>
                <Route key={path} path={path}>
                  <Component />
                </Route>
              )}
              <Route path="/">
                <Home />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default withStyles (styles) (App);
